import { AboutService } from './about.service';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LightboxModule } from 'angular2-lightbox';
import { AboutComponent } from './about.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
	imports: [
		BrowserModule,
		CommonModule,
		HttpModule,
		LightboxModule,
		RouterModule,
		SharedModule,
	],
	declarations: [
		AboutComponent
	],
	providers: [
		AboutService
	],
})
export class AboutModule {}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/about/about.module.ts